{
  "tabs": {
    "summaryOfImages": "Resumo de imagens",
    "userAnalytics": "Análise de Usuários",
    "graderScorecard": "Scorecard de Classificadores",
    "mbGatewayMovement": "Movimentação de Gateways MB",
    "beefAnalytics": "Análise de Carne",
    "ausMeatOmm": "AUS-MEAT OMM",
    "imageComparison": "Comparação de Imagens",
    "wagyu": "Wagyu"
  },
  "wagyu": {
    "libraryTitle": "Biblioteca de Referência de Marmoreio Wagyu",
    "librarySubtitle": "Uma referência visual do marmoreio do olho de lombo na escala USDA, com equivalentes de Marmoreio AUS. Usada para alinhamento de classificadores, treinamento e discussões de posicionamento de marca.",
    "gridTitle": "Grade de Referência de Olho de Lombo Wagyu",
    "gridSubtitle": "{{perBucket}} amostras por faixa de marmoreio USDA de 25 pts · {{brackets}} faixas · {{cells}} células",
    "axisLabel": "Pontuação de marmoreio USDA (faixas de 25 pts)",
    "gridShowing": "Mostrando faixas {{from}} – {{to}} de {{total}}",
    "gridScrollHintBefore": "Role",
    "gridScrollHintAfter": "para marmoreio mais alto",
    "prevBrackets": "Faixas anteriores",
    "nextBrackets": "Próximas faixas",
    "usda": "Marmoreio USDA",
    "ausMarbling": "Marmoreio AUS",
    "msa": "MSA",
    "barcode": "Código de barras",
    "date": "Data e hora",
    "usdaShort": "USDA",
    "ausShort": "AUS",
    "imageAlt": "Amostra Wagyu {{barcode}}",
    "selectedSample": "Amostra selecionada",
    "bracket": "Faixa",
    "close": "Fechar"
  },
  "imageComparison": {
    "newImageComparison": "Nova Comparação de Imagens",
    "reset": "Redefinir",
    "imagesForComparison": "Imagens para comparação",
    "compareAgainst": "Comparar com imagens {{stream}}",
    "selectImagesCapture": "Selecione imagens capturadas pela sua equipe",
    "selectFromStream": "Selecione de imagens classificadas {{stream}} (Anonimizadas)",
    "clearAllFilters": "Limpar todos os filtros",
    "saveView": "Salvar uma visualização",
    "save": "Salvar",
    "viewName": "Nome da visualização",
    "enterViewName": "Digite um nome para esta visualização",
    "subTitle": "Subtítulo (Ex: raça específica, marca, local ou grau)",
    "addDescription": "Adicionar descrição (opcional)",
    "saveViewButton": "Salvar visualização",
    "compareAgainstUSDA": "Comparar com Imagens Classificadas USDA",
    "compareAgainstAUS": "Comparar com Imagens Classificadas AUS Marble",
    "createComparisons": "Criar comparações de imagens e visualizações",
    "chooseFilters": "Escolha alguns filtros acima para começar",
    "noImagesFound": "Nenhuma imagem encontrada para os filtros selecionados",
    "adjustFilters": "Ajuste os filtros ou período acima",
    "view": "Visualização",
    "filters": "Filtros",
    "filtersCompared": "Filtros comparados",
    "created": "Criado",
    "deleteView": "Excluir visualização",
    "savedViews": "Visualizações Salvas",
    "savedViewsPlaceholder": "Visualizações salvas serão mostradas aqui",
    "filter": "Filtro",
    "noImage": "Sem imagem",
    "pageOf": "Página {{page}} de {{totalPages}}",
    "showAllTraits": "Mostrar todos os traços"
  },
  "userAnalytics": {
    "avgCameraScoresPerDay": "Média de Pontuações da Câmera por dia",
    "avgOverridesPerDay": "Média de Substituições por dia",
    "avgOverrideUnderScoresPerDay": "Média de Substituições Abaixo por dia",
    "avgOverrideOverScoresPerDay": "Média de Substituições Acima por dia",
    "cameraUserSummary": "Resumo do Usuário da Câmera",
    "cameraUser": "Usuário da Câmera",
    "totalShifts": "Total de Turnos",
    "shifts": "Turnos",
    "total": "total",
    "totalBarcodesScanned": "Total de Códigos de Barras Escaneados",
    "barcodes": "Códigos de Barras",
    "totalScanned": "total escaneado",
    "avgOverride": "Média de Substituição",
    "avgUnderScore": "Média Abaixo da Pontuação",
    "avgOverScore": "Média Acima da Pontuação",
    "perShift": "por turno",
    "agreementRate": "Taxa de Concordância",
    "underScore": "Pontuação Abaixo",
    "overScore": "Pontuação Acima",
    "underScorePct": "Pontuação Abaixo %",
    "overScorePct": "Pontuação Acima %",
    "barcodesScanned": "Códigos de Barras Escaneados",
    "date": "Data",
    "scoreDifference": "Diferença de Pontuação",
    "scoreDifferencePerDayTitle": "Diferença de Pontuação por dia ({{metric}})",
    "scoreDifferencePerDay": "Diferença de Pontuação por dia",
    "scoreDifferencePerDayDesc": "Estamos destacando quantas vezes um usuário da câmera pontua acima, abaixo ou concorda com a classificação da Câmera MEQ. Flutuações significativas impactarão custos e qualidade.",
    "scoreDifferencePerDaySubtitle": "Mostra pontuações acima e abaixo do usuário da câmera versus câmera por dia, amplie para detalhes.",
    "cameraUserAll": "Usuário da Câmera - Todos",
    "overrideScoreAll": "Pontuação de substituição - Todas",
    "overrideHigherBy": "Pontuação de substituição maior por",
    "overrideLowerBy": "Pontuação de substituição menor por",
    "overrideAgrees": "Pontuação de substituição concorda com a câmera",
    "inOutOfGradings": "em {{n}} de {{m}} classificações",
    "frequency": "Frequência",
    "scoreDifferenceDistribution": "Distribuição de Diferença de Pontuação",
    "scoreDifferenceDistributionDesc": "Com base no período selecionado no topo da tela. Estamos destacando a frequência geral de pontuações abaixo, acima e concordâncias de um classificador com a Câmera MEQ.",
    "scoreDifferenceDistributionSubtitle": "Mostra quantidade de diferença de pontuação para a câmera, amplie para detalhes.",
    "graderHigherBy": "Classificador acima por {{n}}, {{frequency}} vezes",
    "graderLowerBy": "Classificador abaixo por {{n}}, {{frequency}} vezes",
    "graderAgrees": "Classificador concorda com a câmera, {{frequency}} vezes",
    "numberOfOverUnderScores": "Número de Pontuações Acima/Abaixo",
    "overScoreVsUnderScorePerDay": "Pontuação Acima vs Abaixo por dia",
    "overScoreVsUnderScorePerDayDesc": "Mostra os números diários de pontuação acima e abaixo por usuário.",
    "overScoreVsUnderScorePerDaySubtitle": "Mostra números diários de pontuação acima e abaixo dos usuários da câmera.",
    "cameraUserOverScoreClick": "Usuário da Câmera: {{name}} | Contagem Acima: {{count}} | Clique para mais",
    "cameraUserUnderScoreClick": "Usuário da Câmera: {{name}} | Contagem Abaixo: {{count}} | Clique para mais",
    "imagesTitle": "Imagens de {{metric}}",
    "imagesSubtitle": "{{date}} · {{frequency}} {{percentage}}",
    "gradingImagesTitle": "Imagens de {{user}}",
    "gradingSelection": "Câmera {{score}} → Classificador {{override}}",
    "overrideScore": "Nota de substituição"
  },
  "beefAnalytics": {
    "probeRunningAvg": "Média Corrente da Sonda",
    "cameraRunningAvg": "Média Corrente da Câmera",
    "ausMarbling": "Marmoreio AUS",
    "avgDifferenceCameraProbe": "Diferença Média Câmera-Sonda",
    "precisionOfProbe": "Precisão da Sonda",
    "precisionOfProbeSubtitle": "% Pontuação Câmera >= Pontuação Sonda",
    "carcases": "Carcaças",
    "numberOfDarkCutters": "Número de Cortes Escuros",
    "volumeOfCarcases": "Volume de carcaças com PH acima de 5.7",
    "totalCarcases": "Total de Carcaças: {{value}}",
    "phRange": "PH: {{start}} - {{end}} | Carcaças: {{count}}",
    "eyeMuscleArea": "Área do Músculo do Olho (cm2)",
    "marblingVsEyeMuscleArea": "Marmoreio vs Área do Músculo do Olho (cm2)",
    "distributionOfCarcases": "Distribuição de carcaças",
    "camera": "Câmera",
    "probe": "Sonda",
    "eyeMuscleAreaMarbling": "Área do Músculo do Olho (cm2): {{x}} | Marmoreio AUS: {{y}}"
  },
  "summaryOfImages": {
    "captureDays": "Dias de Captura",
    "captureDate": "Data",
    "totalImages": "Total de Imagens",
    "dcuLite": "DCU Lite",
    "averages": "Médias",
    "actions": "Ações",
    "viewDetails": "Ver detalhes",
    "viewDetailsForDate": "Ver detalhes de {{date}}",
    "viewImages": "Ver imagens",
    "viewGraders": "Ver classificadores",
    "gradersTitle": "Classificadores em {{date}}",
    "gradersEmpty": "Nenhum classificador registrado neste dia",
    "averagesTitle": "Médias de {{date}}",
    "downloadDay": "Baixar este dia",
    "imagesGradedBy": "{{count}} imagens · Classificadas por {{graders}}",
    "imagesCount": "{{count}} imagens",
    "listOfImages": "Lista de imagens",
    "dayLine": "· {{date}} - {{images}} Imagens",
    "dayImagesFiltered": "{{label}} {{matched}}/{{total}}",
    "dayImagesFilteredMultiple": "Filtrado para {{matched}}/{{total}}",
    "noValue": "—",
    "location": "Unidade",
    "downloadCsvRangeLabel": "Intervalo de datas",
    "downloadCsvRangePlaceholder": "Selecione um intervalo de datas",
    "downloadCsvMaxRangeError": "Selecione um intervalo de no máximo {{max}} dias",
    "downloadCsvButton": "Baixar CSV",
    "downloadCsvSuccess": "O download do seu CSV foi iniciado",
    "downloadCsvError": "Falha ao baixar o CSV. Tente novamente."
  },
  "imagesModal": {
    "close": "Fechar",
    "viewMode": "Modo de visualização",
    "modeTable": "Lista",
    "modeGrid": "Imagens",
    "filters": "Filtros",
    "filterAll": "Todos",
    "filterGrader": "Classificador",
    "filterUsdaGrade": "Grau USDA",
    "filterAusMarbling": "Marmoreio AUS",
    "filterMeatColor": "Cor da carne",
    "filterFatColor": "Cor da gordura",
    "gradePrime": "Prime",
    "gradeChoice": "Choice",
    "gradeSelect": "Select",
    "gradeStandard": "Standard",
    "filterSex": "Sexo",
    "filterMsaGrading": "Classificação MSA",
    "filterMsaOnly": "MSA",
    "filterNonMsaOnly": "Não MSA",
    "filterDcuLite": "DCU Lite",
    "filterDcuLiteOnly": "DCU Lite",
    "filterStandardOnly": "Padrão",
    "filterEmaMissedOnly": "Somente EMA não capturada",
    "filterBodyIdRange": "Intervalo de número do corpo",
    "filterBodyIdFrom": "Número do corpo de",
    "filterBodyIdTo": "Número do corpo até",
    "filterBodyIdInvalid": "\"Até\" deve ser maior ou igual a \"de\"",
    "filterEmaMissing": "EMA ausente",
    "filterBodyId": "Número do corpo",
    "filtersClear": "Limpar filtros",
    "sortBy": "Ordenar por",
    "sortByColumn": "Ordenar por: {{column}}",
    "sortNone": "Sem ordenação",
    "sortDirection": "Direção da ordenação",
    "sortAscending": "Crescente",
    "sortDescending": "Decrescente",
    "noImages": "Nenhuma imagem corresponde a estes filtros",
    "tileBody": "Corpo {{value}}",
    "imageDetails": "Detalhes da imagem",
    "imagePosition": "Imagem {{current}} de {{total}}",
    "previousImage": "Imagem anterior",
    "nextImage": "Próxima imagem",
    "noValue": "—",
    "drillFilterRemove": "Mostrar todas as imagens"
  },
  "ausMeatOmm": {
    "cameraUserSummary": "Resumo do Usuário da Câmera",
    "date": "Data",
    "status": "Status",
    "carcaseCount": "Contagem de Carcaças",
    "notGenerated": "Não Gerado",
    "generated": "Gerado",
    "sent": "Enviado",
    "ommConfiguration": "Configuração OMM",
    "view": "Visualizar",
    "generate": "Gerar",
    "download": "Baixar",
    "csv": "CSV",
    "send": "Enviar",
    "ommMessages": "Mensagens OMM",
    "ommFileGenerated": "Arquivo OMM gerado.",
    "ommFileSent": "Arquivo OMM enviado.",
    "failedToSendOmm": "Falha ao enviar arquivo OMM.",
    "ommDataNotFound": "Dados OMM não encontrados",
    "noOmmFileToSend": "Nenhum arquivo OMM disponível para enviar",
    "ommFileNotFound": "Arquivo OMM não encontrado.",
    "savedOmmConfig": "Configuração OMM salva com sucesso.",
    "failedToSaveOmmConfig": "Falha ao salvar configuração OMM.",
    "apiKey": "Chave API",
    "establishmentNumber": "Número do Estabelecimento",
    "chainNumber": "Número da Cadeia",
    "cancel": "Cancelar",
    "save": "Salvar"
  },
  "graderScorecard": {
    "title": "Scorecard de Classificadores",
    "description": "Resumo diário da concordância do classificador com a câmera, uma coluna por classificador. Cada valor é um % dos corpos escaneados desse classificador — clique em uma célula para ver as contagens.",
    "metric": "Métrica",
    "order": "Ordem",
    "agreementPct": "% Concordância",
    "overPct": "% Acima",
    "underPct": "% Abaixo",
    "orderAz": "A–Z",
    "orderMostAgreement": "Maior → Menor Concordância",
    "distribution": "Distribuição",
    "distributionHint": "Separar % Acima / % Abaixo pela distância da substituição (diferença de 1, de 2, 3+)",
    "distributionAgreementHint": "Mude para % Acima ou % Abaixo para separar pela distância da substituição",
    "distributionFootnote": "A distribuição usa corpos classificados (com pontuação da câmera) como denominador, então os valores podem diferir ligeiramente da visão simples",
    "dateRange": "Período",
    "from": "De",
    "to": "Até",
    "apply": "Aplicar",
    "date": "Data",
    "shiftsAndScans": "{{shifts}} turnos · {{scans}} escaneamentos",
    "periodAvg": "Média de {{days}} dias",
    "good": "Bom",
    "warning": "Atenção",
    "bad": "Ruim",
    "legendFootnote": "Os valores são % dos corpos escaneados do classificador · clique em uma célula para ver as contagens",
    "noData": "Sem dados de classificação para o período selecionado.",
    "decisionMixTitle": "Mix de Decisões de {{days}} Dias",
    "decisionMixDescription": "O período selecionado de cada classificador dividido por distância de sobreposição, ordenado da maior para a menor concordância. A cor indica a distância, a posição indica a direção — pontuação abaixo à esquerda, acima à direita.",
    "decisionMixAgreement": "Concordância",
    "decisionMixUnderBy2Plus": "Abaixo em 2 ou mais",
    "decisionMixUnderBy1": "Abaixo em 1",
    "decisionMixOverBy1": "Acima em 1",
    "decisionMixOverBy2Plus": "Acima em 2 ou mais",
    "decisionMixScans": "{{scans}} escaneamentos",
    "dayBreakdownDecisions": "Decisões",
    "dayBreakdownAgreement": "Concordância",
    "dayBreakdownOver": "Acima",
    "dayBreakdownUnder": "Abaixo",
    "dayBreakdownBodies_one": "{{count}} corpo",
    "dayBreakdownBodies_other": "{{count}} corpos",
    "dayBreakdownDrillHint": "Selecione um cartão ou linha para ver suas imagens.",
    "dayBreakdownRowLabel": "Diferença de {{label}}",
    "dayBreakdownViewImages": "Ver imagens: {{label}}",
    "dayBreakdownOverTitle": "Pontuação acima — classificador acima da câmera",
    "dayBreakdownUnderTitle": "Pontuação abaixo — classificador abaixo da câmera",
    "dayBreakdownDescription": "{{total}} decisões de classificação em relação à MEQ Camera em {{trait}}. As porcentagens são a parcela dessas {{total}} decisões."
  },
  "mbGatewayMovement": {
    "title": "Movimentação de Gateways MB",
    "titleInfo": "Como as alterações dos classificadores movem carcaças entre os gateways de marca definidos em Preços dos gateways, e quanto essa movimentação vale por cabeça.",
    "pricingButton": "Preços dos gateways",
    "loadError": "Não foi possível carregar os preços dos gateways salvos.",
    "pricing": {
      "title": "Preços dos gateways",
      "info": "Defina um valor em $ / cabeça para cada gateway MB. Um gateway com valor acima de 0 abre uma faixa de marca; uma carcaça pertence à faixa do gateway com preço mais próximo igual ou abaixo da sua nota. Mover uma carcaça através de um gateway vale o valor desse gateway. MB 0 é o piso e não tem gateway.",
      "columnGateway": "Gateway",
      "columnProgram": "Marca / programa",
      "columnValuePerHead": "$ / cabeça",
      "columnBoundary": "Limite de marca",
      "gatewayLabel": "MB {{grade}}+",
      "opensBand": "✓ abre uma faixa",
      "programPlaceholder": "Nome do programa",
      "programLabel": "Marca / programa para MB {{grade}}+",
      "priceLabel": "$ / cabeça para MB {{grade}}+",
      "priceErrors": {
        "notANumber": "Informe um número",
        "negative": "Não pode ser negativo",
        "tooLarge": "No máximo $100.000",
        "decimals": "No máximo 2 casas decimais"
      },
      "bandRange": "MB {{start}}–{{end}}",
      "bandSingle": "MB {{start}}",
      "unnamedBand": "Marca sem nome",
      "belowFirstBand": "sem marca",
      "bandsLabel": "Faixas",
      "noBands": "Nenhuma faixa definida — os valores em $ serão ocultados",
      "thresholdBefore": "as maiores movimentações — pelo menos",
      "thresholdAfter": "% do valor movimentado",
      "thresholdInfo": "Uma movimentação recebe uma estrela quando seu impacto em $ é pelo menos esta parcela de todo o valor movimentado no período selecionado, para que as movimentações mais importantes se destaquem independentemente de quantas carcaças envolvem.",
      "thresholdLabel": "Limite das maiores movimentações (%)",
      "thresholdErrors": {
        "notANumber": "Informe um número",
        "outOfRange": "Maior que 0, no máximo 100"
      },
      "reset": "Redefinir",
      "cancel": "Cancelar",
      "apply": "Aplicar",
      "saveError": "Não foi possível salvar os preços dos gateways. {{message}}"
    },
    "siteLabel": "Unidade",
    "matrixLoadError": "Não foi possível carregar a movimentação de classificação para este período.",
    "kpis": {
      "bodiesGraded": "Carcaças classificadas",
      "bodiesGradedSub": "{{share}} de acordo com a câmera",
      "moved": "Mudaram de grau MB",
      "movedSub": "{{share}} das carcaças",
      "changedBand": "Mudaram de faixa de marca",
      "changedBandSub": "{{share}} das carcaças · {{movementShare}} de toda a movimentação",
      "noBands": "Defina os preços de gateway para ver as faixas de marca",
      "netImpact": "Impacto líquido em $",
      "netImpactSub": "{{gross}} de valor bruto movimentado",
      "noPricing": "Defina os preços de gateway para ver valores em $",
      "trendVsLast": "vs. período anterior",
      "trendPts": "{{value}} p.p.",
      "trendFlat": "Sem alteração",
      "trendUp": "Alta",
      "trendDown": "Queda"
    },
    "ungradedNote_one": "{{bodies}} carcaça não teve grau da câmera e não está na matriz.",
    "ungradedNote_other": "{{bodies}} carcaças não tiveram grau da câmera e não estão na matriz.",
    "show": "Mostrar",
    "modes": {
      "bodies": "Carcaças",
      "pctOfCameraGrade": "% do grau da câmera",
      "pctOfAll": "% de todas as carcaças",
      "value": "Impacto em $"
    },
    "valueModeDisabled": "Defina os preços de gateway para ver o impacto em $",
    "matrix": {
      "finalGradeHeader": "Grau final após ajuste do classificador",
      "cameraGradeHeader": "Grau da câmera",
      "grade": "MB {{grade}}",
      "rowSub": "{{bodies}} carcaças · {{share}}",
      "cameraTotal": "Total da câmera",
      "finalTotal": "Total do grau final",
      "boundaryColumn": "MB {{grade}}+ é um limite de marca",
      "cellLabel": "Câmera MB {{camera}}, final MB {{final}}: {{value}}",
      "material": "Movimentação relevante"
    },
    "legend": {
      "agreed": "Concordância",
      "up": "Classificador subiu",
      "down": "Classificador baixou",
      "boundary": "Cruza um limite de marca",
      "material": "Relevante",
      "allGraders": "todos os classificadores"
    },
    "empty": {
      "title": "Nenhuma carcaça classificada neste período",
      "body": "Tente um período maior ou outro classificador."
    },
    "detail": {
      "title": "Câmera MB {{camera}} → final MB {{final}}",
      "agreedTitle": "Câmera e classificador concordaram em MB {{grade}}",
      "agreedSummary_one": "{{bodies}} carcaça que a câmera classificou como MB {{grade}} foi finalizada como MB {{grade}} — o classificador concordou com a câmera.",
      "agreedSummary_other": "{{bodies}} carcaças que a câmera classificou como MB {{grade}} foram finalizadas como MB {{grade}} — o classificador concordou com a câmera.",
      "moveSummary_one": "{{bodies}} carcaça que a câmera classificou como MB {{camera}} foi finalizada como MB {{final}} pelo classificador — {{movement}}.",
      "moveSummary_other": "{{bodies}} carcaças que a câmera classificou como MB {{camera}} foram finalizadas como MB {{final}} pelo classificador — {{movement}}.",
      "up_one": "um grau acima",
      "up_other": "{{count}} graus acima",
      "down_one": "um grau abaixo",
      "down_other": "{{count}} graus abaixo",
      "bodies": "Carcaças",
      "shareOfCameraGrade": "Parcela da câmera MB {{grade}}",
      "shareValue": "{{bodies}} de {{total}} = {{share}}",
      "impact": "Impacto em $",
      "impactValue": "{{total}} ({{bodies}} × {{perHead}} / cabeça)",
      "boundariesHeading": "Limites de marca cruzados",
      "crosses": "Cruza MB {{grade}}+ ({{program}}, {{perHead}} / cabeça)",
      "crossesUnnamed": "Cruza MB {{grade}}+ ({{perHead}} / cabeça)",
      "sameBand": "Os dois graus estão em {{program}}, então nada mudou no preço.",
      "sameBandUnnamed": "Os dois graus estão na faixa MB {{start}}+, então nada mudou no preço.",
      "sameBelowFirst": "Os dois graus estão abaixo do primeiro gateway de marca, então nada mudou no preço.",
      "noPricing": "Os preços de gateway não estão definidos para esta unidade, então o impacto em $ não é exibido.",
      "material": "Movimentação relevante — pelo menos {{threshold}}% de todo o valor movimentado neste período."
    }
  },
  "columnResolution": {
    "columns": {
      "preset": "Preset da câmera",
      "config": "Config da câmera"
    },
    "source": {
      "declared": "Declarado pelo documento de configurações {{org}} / {{location}}",
      "country": "Padrão do país {{country}}. Ninguém escolheu; aplica-se porque a unidade não tem preset próprio.",
      "legacy": "Sem preset. As colunas vêm dos traits e da lista de bloqueio legados do documento de configurações."
    },
    "legacyChip": "Legado",
    "flags": {
      "deviation": "Desvio",
      "unknown": "Desconhecido",
      "deadLegacy": "Config morta"
    },
    "flagHints": {
      "deviation": "O documento de configurações adiciona, omite, reordena ou reclassifica colunas sobre o preset.",
      "unknown": "A configuração cita colunas que o registro não conhece, por isso são descartadas: {{values}}",
      "deadLegacy": "O documento traz traits ou lista de bloqueio legados que um preset substitui. Eles não fazem nada."
    },
    "title": "Colunas da câmera",
    "spine": "Métricas do dia de captura",
    "columnsList": "Colunas",
    "popover": "Médias do dia",
    "defaultSort": "Ordenação padrão",
    "exportOmit": "Omitido na exportação",
    "unknownValues": "Valores desconhecidos",
    "deadLegacy": "Config legada substituída",
    "deviation": "Desvio como armazenado",
    "ascending": "crescente",
    "descending": "decrescente",
    "none": "nenhum"
  }
}
